import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Contact from './pages/Contact';

// This utility smoothly scrolls to sections when you click a link like "/#about"
function ScrollToHash() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const element = document.getElementById(hash.replace('#', ''));
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);
  return null;
}

function Navbar() {
  return (
    <nav className="bg-white shadow-md sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-20 flex items-center justify-between">
        <Link to="/#home" className="text-3xl font-bold text-blue-900 tracking-tight">
          IPRWL<span className="text-blue-500">.</span>
        </Link>
        <div className="hidden md:flex space-x-8 font-medium text-slate-600">
          <Link to="/#home" className="hover:text-blue-600 transition">Home</Link>
          <Link to="/#about" className="hover:text-blue-600 transition">About Us</Link>
          <Link to="/#services" className="hover:text-blue-600 transition">Services</Link>
          <Link to="/#projects" className="hover:text-blue-600 transition">Projects</Link>
          <Link to="/contact" className="px-5 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition">Contact</Link>
        </div>
      </div>
    </nav>
  );
}

function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-300 py-12 px-6">
      <div className="max-w-7xl mx-auto grid md:grid-cols-3 gap-8 mb-8">
        
        {/* Brand Details */}
        <div>
          <h3 className="text-2xl font-bold text-white mb-4">IPRWL<span className="text-blue-500">.</span></h3>
          <p className="text-sm text-slate-400 leading-relaxed pr-4">
            Providing end-to-end solutions in developing and implementing sustainable water and wastewater infrastructure projects across India.
          </p>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-lg font-bold text-white mb-4">Quick Links</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/#home" className="hover:text-blue-400 transition">Home</Link></li>
            <li><Link to="/#about" className="hover:text-blue-400 transition">About Us</Link></li>
            <li><Link to="/#services" className="hover:text-blue-400 transition">Services</Link></li>
            <li><Link to="/#projects" className="hover:text-blue-400 transition">Projects</Link></li>
            <li><Link to="/contact" className="hover:text-blue-400 transition">Contact Us</Link></li>
          </ul>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-lg font-bold text-white mb-4">Corporate Office</h3>
          <address className="not-italic text-sm text-slate-400 space-y-2">
            <p>IL&FS Water Limited</p>
            <p>Chennai, Tamil Nadu</p>
            <p>Phone: +91 44 4344 3345</p>
            <p>Email: info@iprwl.com</p>
          </address>
        </div>

      </div>
      
      {/* Copyright */}
      <div className="border-t border-slate-800 pt-8 text-center text-sm text-slate-500">
        <p>&copy; {new Date().getFullYear()} IL&FS Paradip Refinery Water Limited. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default function App() {
  return (
    <Router basename="/iprwl-website">
      <ScrollToHash />
      <div className="flex flex-col min-h-screen bg-slate-50 font-sans text-slate-800">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}